import React, {useEffect, useState} from 'react';
import ProductMovingTemplate from './ProductMovingTemplate';
import subStorageService from '../../services/SubStorageService';
import productService from '../../services/ProductService';
import {useTitle} from '../dashboard/TitleContext';
import {useSnackbar} from '../../util/SnackbarProvider';

const ProductMoving = () => {

    useTitle([
        {name: 'Raktár', url: '/dashboard/storage'},
        {name: 'Mozgatás', url: '/dashboard/storage/move'}
    ])

    const [storages, setStorages] = useState([]);
    const [fromStorage, setFromStorage] = useState(JSON.parse(localStorage.getItem("product-storage-from")))
    const [toStorage, setToStorage] = useState(JSON.parse(localStorage.getItem("product-storage-to")))
    const [productItems, setProductItems] = useState([]);
    const [productItem, setProductItem] = useState(JSON.parse(null));
    const [productSearchText, setProductSearchText] = useState(undefined)
    const [isNewProduct, setIsNewProduct] = useState(false)
    const [amount, setAmount] = useState(0)
    const [newProduct, setNewProduct] = useState({})
    const [waitingForServer, setWaitingForServer] = React.useState(false)
    const {sendAlertMessage} = useSnackbar()

    const resetState = () => {
        setAmount(0)
    }

    useEffect(() => {
        subStorageService.search({onlyNonProjects: false})
            .then(response => setStorages(response))
            .catch(error => console.error(error))
    }, []);


    const [fromStorageItemsTable, setFromStorageItemsTable] = useState({rows: null, page: 0, rowsPerPage: 10, totalCount: 0})
    useEffect(() => {
        if (fromStorage == null || !fromStorage?.id) return
        productService.searchProductItemsBySubStorage({
            subStorageId: fromStorage.id,
            page: fromStorageItemsTable.page,
            size: fromStorageItemsTable.rowsPerPage
        })
            .then(response => setFromStorageItemsTable((prev) => ({...prev, rows: response.content, totalCount: response.totalElements})))
            .catch(error => console.error(error))
    }, [fromStorage, fromStorageItemsTable.page, fromStorageItemsTable.rowsPerPage]);

    const [toStorageItemsTable, setToStorageItemsTable] = useState({rows: null, page: 0, rowsPerPage: 10, totalCount: 0})
    useEffect(() => {
        if (toStorage == null || !toStorage?.id) return
        productService.searchProductItemsBySubStorage({
            subStorageId: toStorage ? toStorage.id : null,
            page: toStorageItemsTable.page,
            size: toStorageItemsTable.rowsPerPage
        })
            .then(response => setToStorageItemsTable((prev) => ({...prev, rows: response.content, totalCount: response.totalElements})))
            .catch(error => console.error(error))
    }, [toStorage, toStorageItemsTable.page, toStorageItemsTable.rowsPerPage]);


    useEffect(() => {
        if (!fromStorage) return
        productService.searchProductItemsByName(buildQueryParams())
            .then(response => setProductItems(response.content))
            .catch(error => console.error(error))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productSearchText, fromStorage, toStorage]);

    function buildQueryParams() {
        return {
            page: 0,
            size: 50,
            ...(productSearchText && {searchText: productSearchText}),
            ...(fromStorage?.id && {subStorageId: fromStorage.id}),
        }
    }

    const changeProductSearchText = (text) => {
        setProductSearchText(text)
    }

    const changeStorageFrom = (storage) => {
        localStorage.setItem("product-storage-from", JSON.stringify(storage))
        setFromStorage(storage)
        setFromStorageItemsTable((prev) => ({
            ...prev,
            page: 0
        }))
        setProductItem(JSON.parse(null))
        if (storage && storage.name !== 'Bevételezés') setIsNewProduct(false)
        if (toStorage != null && storage != null && toStorage.id === storage.id) setToStorage(JSON.parse(null))
        if (!storage) {
            setProductItem(JSON.parse(null))
        }
    }

    const changeStorageTo = (storage) => {
        localStorage.setItem("product-storage-to", JSON.stringify(storage))
        setToStorageItemsTable((prev) => ({
            ...prev,
            page: 0
        }))
        setToStorage(storage)
    }
    const handleIsNewProductChange = (e) => setIsNewProduct(e.target.checked)

    const changeProduct = (item) => {
        setProductItem(item)
        if (item) setNewProduct({...item.product, ...item})
        else setNewProduct({})
    }

    const onChangeCheckbox = (event) => {
        const {checked, name} = event.target
        setNewProduct((prevProduct) => ({
            ...prevProduct,
            [name]: checked,
        }));
    };

    const changeAmount = (e) => {
        const a = e.target.value
        if (a < 0) return
        setAmount(a)
    }

    const onNewProductChange = (event) => {
        const {name, value} = event.target;
        setNewProduct((prevProduct) => ({
            ...prevProduct,
            [name]: value,
        }));
    }

    const submit = (e) => {
        e.preventDefault()
        console.log(productItem)
        if (toStorage.name === "Selejtezés") discardProductItems()
        else if (isNewProduct) createProduct()
        else moveProduct()
    }

    const createProduct = () => {
        if (!checkAmount()) return
        setWaitingForServer(true)
        if (toStorage == null) {
            sendAlertMessage("Cél raktár nincs megadva!", "error");
            return
        }
        const subStorageId = toStorage.id;
        productService.createProduct({...newProduct, amount, subStorageId})
            .then(() => {
                sendAlertMessage("Termék sikeresen hozzáadva!")
                resetState()
            })
            .catch(error => sendAlertMessage(error?.message || "Termék bevételezése sikertelen", "error"))
            .finally(() => setWaitingForServer(false))
    }

    const moveProduct = () => {
        if (!checkAmount()) return
        setWaitingForServer(true)
        const request = prepareMovementRequest();
        productService.moveProduct(request)
            .then(() => {
                sendAlertMessage(fromStorage.name === 'Bevételezés' ? "Mennyiség sikeresen hozzáadva!" : "Termék sikeresen áthelyezve!");
                resetState()
            })
            .catch(error => sendAlertMessage(error?.message || "Termék mozgatása sikertelen", "error"))
            .finally(() => setWaitingForServer(false))
    }

    const discardProductItems = () => {
        if (!checkAmount()) return
        setWaitingForServer(true)
        productService.discardProductItems(productItem.id, amount)
            .then(() => {
                sendAlertMessage("Termékek sikeresen leselejtezve!");
                resetState()
            })
            .catch(error => sendAlertMessage(error?.message || "Termékek leselejtezése sikertelen", "error"))
            .finally(() => setWaitingForServer(false))
    }

    const checkAmount = () => {
        if (amount <= 0) {
            sendAlertMessage("Mennyiség pozitív érték kell legyen!", "error")
            return false
        }
        return true
    }

    const prepareMovementRequest = () => {
        return ({
            ...newProduct,
            amount,
            subStorageId: toStorage.id,
            fromSubStorageId: fromStorage.id,
            productItemId: productItem.id
        })
    }

    const onChangeSelectItem = (newValue, field) => {
        setNewProduct((prevProduct) => ({
            ...prevProduct,
            [field]: newValue,
        }));
    };

    const handleFromStorageChangePage = (event, newPage) => {
        setFromStorageItemsTable((prev) => ({
            ...prev,
            page: newPage
        }))
    };

    const handleFromStorageChangeRowsPerPage = (event) => {
        const rowsPerPage = event.target.value
        setFromStorageItemsTable((prev) => ({
            ...prev,
            rowsPerPage: rowsPerPage,
            page: 0
        }))
    };

    const handleToStorageChangePage = (event, newPage) => {
        setToStorageItemsTable((prev) => ({
            ...prev,
            page: newPage
        }))
    };

    const handleToStorageChangeRowsPerPage = (event) => {
        const rowsPerPage = event.target.value
        setToStorageItemsTable((prev) => ({
            ...prev,
            rowsPerPage: rowsPerPage,
            page: 0
        }))
    };

    return (
        <ProductMovingTemplate
            {...{
                storages,
                fromStorage,
                productItem,
                productItems,
                amount,
                isNewProduct,
                newProduct,
                toStorage,
                waitingForServer,
                handleIsNewProductChange,
                changeStorageFrom,
                changeStorageTo,
                changeProduct,
                changeAmount,
                changeProductSearchText,
                onNewProductChange,
                onChangeCheckbox,
                onChangeSelectItem,
                submit,
                fromStorageItemsTable,
                toStorageItemsTable,
                handleFromStorageChangePage,
                handleFromStorageChangeRowsPerPage,
                handleToStorageChangePage,
                handleToStorageChangeRowsPerPage
            }}
        />
    );
};

export default ProductMoving;
